var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAnss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-f63eb78e-e061-4272-a93e-e71c08e218df",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-4d20fe45-0183-4d3b-a9af-f61b8d4abc86{fill:#fff;}.uuid-c6754553-277c-470a-a128-68bf494e675b{fill:#ffb71b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-4b9ce04e-ac8b-4d4f-a8e9-2c295dca9726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-72eb0e6b-16d7-44c2-85b4-17d6167afca5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-bae397e8-48bc-4582-b491-c8aeb5e4abb3",
    className: "uuid-c6754553-277c-470a-a128-68bf494e675b",
    d: "m283.18,120.7l-110.19,270.61h-74.26L209.1,120.7h74.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-16a907b7-27b1-4cb5-9884-59d3bfc9f08c",
    className: "uuid-4d20fe45-0183-4d3b-a9af-f61b8d4abc86",
    d: "m301.25,129.36l112.02,261.94h-79.51l-70.45-170.96,37.93-90.98Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnss);
export default __webpack_public_path__ + "static/media/icon_anss.7b22d636805d773afaa0a2c1a110a947.svg";
export { ForwardRef as ReactComponent };